define([
    'text!fnjinews2021/component/swiper-video.html',
    // 'common/api',
    'jquery',
    '../../../../vendor/swiper/swiper-bundle.min.js',

    'css!vendor/swiper/swiper-bundle.min.css',
    'css!fnjinews2021/component/swiper-video.css'

], function(
    tpl,
    // Api,
    $,
    Swiper
){
    return {
        template: tpl,
        data: function(){
            return {
                isPC: true,
                thePage: 0,
                videoSwiper: {},
                SwiperImage: [
                    {name: '2024新品广告片',time: '2024年10月',
                        img: 's20480_1729236285_9868.jpg',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/66a3cf011397757895645183938/v.f100040.mp4'},
                    {name: '2024新品广告片',time: '2024年6月',
                        img: 's20480_1729236119_9317.jpg',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/71f1ed301397757895645631320/v.f100030.mp4'},
                    {name: '冰山沙发宣传片',time: '2021年',
                        img: 's20480_1627525858_4140.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/bedae17b3701925921700019554/v.f30.mp4'},
                    {name: '梵游记',time: '2019年',
                        img: 's20480_1627526616_2558.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/ba35047e5285890799896941222/v.f20.mp4'},
                    {name: '李宅夏午',time: '2018年',
                        img: 's20480_1627526124_2093.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/10240b895285890805950262109/v.f20.mp4'},
                    {name: 'FF线宣传片',time: '2018年',
                        img: 's20480_1627526246_5860.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/14e234925285890805950475751/v.f20.mp4'},
                    {name: '2017新品广告片',time: '2017年',
                        img: 's20480_1627526269_6608.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/a271987e3701925921713729311/v.f30.mp4'},
                    {name: '春夏秋冬',time: '2014年',
                        img: 's20480_1627526343_2499.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/d869deca5285890805966888967/v.f20.mp4'},
                    {name: '2013年新品广告片',time: '2013年',
                        img: 's20480_1627526368_7352.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/22b1a9995285890805967733573/v.f30.mp4'}
                ]
            };
        },
        // 这里是传入的数据
        props: {
            SlickImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            },
            // SwiperImage: {
            //     type: Array,
            //     default: function () {
            //         return []
            //     }
            // },
            SwiperType: String
        },
        methods: {
            pcIs: function(){
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                }else {
                    obj.isPC = true;
                }
            },
            init: function () {
                var obj = this;
                if(obj.SwiperType=='video'){
                    obj.videoSwiper = new Swiper('#swiper-video',{
                        // slidesPerView: 'auto',
                        // spaceBetween: 100,
                        // observer: true, // 修改swiper自己或子元素时，自动初始化swiper
                        // centeredSlides: true,
                        // effect: 'coverflow',
                        // coverflow:{
                        //     rotate:0,//slide做3d旋转时Y轴的旋转角度。默认50。
                        //     stretch:100,//每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
                        //     depth:150,//slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
                        //     modifier:1,//depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
                        //     slideShadows:false,//开启slide阴影。默认 true。
                        // },
                        // on: {
                        //     slideChangeTransitionEnd: function () {
                        //         // obj.thePage = this.activeIndex;
                        //         $('.swiper-the-video').trigger('pause');
                        //     }
                        // }
                        autoWeight: 'auto',
                        slidesPerView: 'auto',
                        spaceBetween: 30,
                        lazyLoading : true,
                        observer: true,
                        on: {
                            slideChangeTransitionEnd: function () {
                                $('.swiper-the-video').trigger('pause');
                                obj.thePage = this.activeIndex;
                            }
                        }
                    });
                    // obj.$set(obj.thePage,obj.thePage);
                }
                // console.log(obj.videoSwiper);
            },
            toPage: function(index){
                var obj = this;
                if(index==1){
                    if(parseInt(obj.thePage)<obj.SwiperImage.length){
                        obj.thePage+=1;
                    }
                }else {
                    if(parseInt(obj.thePage)>0){
                        obj.thePage-=1;
                    }
                }
                obj.videoSwiper.slideTo(obj.thePage);
            }
        },
        watch: {
            SwiperImage: function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
            this.pcIs();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./fnjinews2021/component/swiper-video.js
// module id = 137
// module chunks = 0